import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Form, Modal } from "react-bootstrap";
import ApiService from "../../helper/api";
import AlertService from "../../helper/alertService";
import { LoadingContext } from "../../App";
import ActionButton from "../../componets/ActionButon";
import MainService from "../../helper/mainService";

const ConfigForm = ({ confige, closeModal, isShowForm, setData }) => {
	const { addButtonSpinner, removeButtonSpinner } = useContext(LoadingContext);
	const [values, setValues] = useState({
		name: "",
		value: "",
		description: "",
	});

	useEffect(() => {
		if (confige) {
			const newValues = {};
			Object.entries(values).forEach(([key, value]) => {
				if (confige[key]) {
					newValues[key] = confige[key];
				}
			});
			newValues.id = confige.id;
			setValues(values => ({ ...values, ...newValues }));
		}
	}, [confige]);

	const onChange = (event, name) => {
		setValues(values => ({
			...values,
			[name]: event.target.value,
		}));
	};

	const onSubmit = e => {
		e && e.preventDefault();
		const id = Math.random();
		addButtonSpinner(id);
		if (confige) {
			values.id = confige.id;
		}
		MainService.callApi({
			api: confige ? ApiService.configUpdate : ApiService.configCreate,
			showSpinner: false,
			data: values,
			cb: response => {
				if (!values && response.data) {
					setData(data => [...data, response.data]);
					AlertService.alert("success", "Data Saved");
					_closeModal();
				} else if (confige && response.success) {
					AlertService.alert("success", "Data Saved");
					_closeModal();
					setData(data =>
						data.map(item => {
							if (item.id === values.id) {
								return { ...item, ...values };
							}
							return item;
						}),
					);
				}
			},
			_finally: () => {
				removeButtonSpinner(id);
			},
		}).finally(() => {
			removeButtonSpinner(id);
		});
		// (!confige
		// 	? ApiService.createNetworkPlatform(values)
		// 	: ApiService.updateNetworkPlatform(values)
		// )
		// 	.then(response => {
		// 		AlertService.alert("success", "Data Saved");
		// 		_closeModal();
		// 	})
		// 	.catch(error => {
		// 		AlertService.alert(
		// 			AlertService.checkMessageType(error.respcode) || "error",
		// 			error,
		// 		);
		// 	})
	};

	const _closeModal = () => {
		setValues({
			name: "string",
			value: "string",
			description: "string",
			isDefault: true,
			isReadonly: true,
		});
		closeModal();
	};

	return (
		<form onSubmit={onSubmit}>
			<Modal
				show={isShowForm || confige}
				size="lg"
				scrollable
				onHide={() => {
					_closeModal();
				}}>
				<Modal.Header closeButton>
					<Modal.Title>{confige ? "Update" : "Create"} Confige</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col md={12}>
							<Row className="justify-content-between">
								{/* Name */}
								<Col md={6}>
									<Form.Group className="mb-1" controlId="name">
										<Form.Label>Name</Form.Label>
										<Form.Control
											type="text"
											placeholder="Name"
											required={true}
											value={values.name}
											onChange={event => {
												onChange(event, "name");
											}}
										/>
									</Form.Group>
								</Col>
								<Col md={6}>
									<Form.Group className="mb-1" controlId="value">
										<Form.Label>Value</Form.Label>
										<Form.Control
											type="text"
											placeholder="Value"
											required={true}
											value={values.value}
											onChange={event => {
												onChange(event, "value");
											}}
										/>
									</Form.Group>
								</Col>
								<Col md={12}>
									<Form.Group className="mb-3" controlId="description">
										<Form.Label>Description</Form.Label>
										<Form.Control
											as="textarea"
											required={true}
											placeholder="Description"
											rows={3}
											value={values.description}
											onChange={event => {
												onChange(event, "description");
											}}
										/>
									</Form.Group>
								</Col>

								{/* Is active */}
								<Col md={12}>
									<Form.Group className="mb-1" controlId="isDefault">
										<Form.Label>Is Default </Form.Label>
										<Form.Check // prettier-ignore
											type="switch"
											id="isActive"
											label="yes"
											checked={values.isDefault}
											onChange={event => {
												setValues(values => ({
													...values,
													isDefault: event.target.checked,
												}));
											}}
										/>
									</Form.Group>
								</Col>
							</Row>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					{/* <Button variant="secondary" onClick={handleClose}>
						Close
					</Button>
					<Button variant="primary" onClick={handleClose}>
						Save Changes
					</Button> */}
					<Col md={12}>
						<ActionButton
							cb={onSubmit}
							// isEnabled={!values.networkType || !values.name}
						/>
					</Col>
				</Modal.Footer>
			</Modal>
		</form>
	);
};

export default ConfigForm;
